<template>
  <div>
    <form id="frm-dictum"
          ref="frm-dictum"
          accept-charset="UTF-8"
          class="card"
          method="GET"
          onsubmit="return false">
      
      <div class="card-header">
        <h1 class="card-title mb-0">Dictamen de la enmienda</h1>
      </div>
      <div class="card-body">
        
        <p class="mb-4">Ingrese los datos solicitados para poder aplicar el dictamen.</p>
        
        <div class="form-group">
          <label class="d-block font-weight-normal"
                 for="dictum_type_key">Tipo de dictamen:
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <select id="dictum_type_key"
                  v-model="dictum_type_key"
                  class="custom-select"
                  name="dictum_type_key">
            <option disabled
                    value="">
              Seleccione el tipo de dictamen
            </option>
            <option v-for="option in dictumTypes"
                    :key="option.key"
                    :value="option.key">
              {{ option.title }}
            </option>
          </select>
        </div>
        
        <div class="form-group">
          <label class="d-block font-weight-normal"
                 for="file">Archivo:
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          
          <div class="custom-file">
            <input id="file"
                   ref="file"
                   accept="application/pdf"
                   class="custom-file-input"
                   name="file"
                   type="file">
            <label for="file" class="custom-file-label">Archivo de dictamen</label>
          </div>
        </div>
        <div class="form-group">
          <label class="d-block font-weight-normal"
                 for="comments">Comentarios:
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <textarea id="comments"
                    v-model="comments"
                    class="form-control"
                    name="comments"
                    placeholder="Ingrese sus comentarios..."
                    rows="3"></textarea>
        </div>
      </div>
      <div class="card-footer d-flex py-2 px-2">
        <button class="btn btn-lg btn-primary mr-2"
                type="submit">Registrar dictamen
        </button>
      </div>
    </form>
    
    <portal to="modals">
      <ok-cancel-dialog id="accept-dictum-modal"
                        ref="accept-dictum-modal"
                        content="<p>¿Esta seguro de guardar este dictamen?</p>"
                        ok-button-text="Confirmar"
                        title="Guardar dictamen"
                        @ok-button-pressed="saveDictum"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import OkCancelDialog from '../../ui/OkCancelDialog'
  import { mapActions, mapGetters } from 'vuex'
  import autosize from 'autosize'
  
  export default {
    name: 'DictumAmendment',
    components: {
      OkCancelDialog,
    },
    data() {
      return {
        dictum_type_key: '',
        require_renewal: null,
        comments: '',
      }
    },
    props: {
      amendment: Object,
      committee: Object,
      task: Object,
    },
    computed: {
      ...mapGetters(['user']),
      ...mapGetters({
        dictumTypes: 'amendments/dictumTypes',
      }),
    },
    methods: {
      ...mapActions({
        getDictumTypes: 'amendments/getDictumTypes', // TODO: Change this.
      }),
      
      async saveDictum() {
        this.$refs['accept-dictum-modal'].sending = true
        
        const formData = new FormData()
        
        formData.append('amendment_id', this.amendment.id)
        formData.append('amendment_type', this.amendment.type.key)
        formData.append('committee_id', this.committee.id)
        formData.append('task_id', this.task.id)
        formData.append('dictum_type_key', this.dictum_type_key)
        formData.append('file', this.$refs.file.files[0])
        formData.append('comments', this.comments)
        
        this.$emit('register-dictum', formData, () => {
          this.$refs['accept-dictum-modal'].sending = false
          this.$refs['accept-dictum-modal'].close()
        })
      },
      
      async load() {
        const { amendment, committee } = this
        
        await this.getDictumTypes({
          amendment,
          committee,
        })
      },

      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      }
    },
    async mounted() {
      const vm = this

      autosize(document.getElementsByTagName('textarea'))
      
      $('#frm-dictum').validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(label, element) {
          label.addClass('invalid-feedback')
          label.insertAfter(element)
        },
        rules: {
          dictum_type_key: {
            required: true,
          },
          comments: {
            required: true,
          },
          file: {
            required: true,
            extension: 'pdf',
            maxsize: (vm.isAdmin() ? 5 : 2) * 1024 * 1024,
          },
        },
        messages: {
          dictum_type_key: {
            required: 'Este campo es requerido.',
          },
          comments: {
            required: 'Este campo es requerido.',
          },
          file: {
            required: 'Este campo es requerido.',
            extension: 'El formato del archivo debe ser PDF.',
            maxsize: `El tamaño del archivo no debe superar los ${ vm.isAdmin() ? 5 : 2 } MB.`,
          },
        },
        submitHandler(form) {
          $('#accept-dictum-modal').modal('show')
        },
      })
      
      await this.load()
    },
  }
</script>
